import { WifiOff } from 'lucide-react';

/**
 * Looks like a generic browser/device connectivity error, not an access-restriction
 * message — intentionally does not reveal that content is being withheld or why.
 * Mirrors the static fallback markup in index.html so the same message is present
 * in the raw page source, not just conditionally rendered by React.
 */
export default function NetworkIssueScreen() {
  return (
    <div className="relative flex h-screen w-screen items-center justify-center overflow-hidden bg-background px-4">
      <div className="pointer-events-none absolute inset-0 opacity-40 blur-sm select-none" aria-hidden="true">
        <div className="h-full w-full bg-gradient-to-br from-muted via-background to-muted" />
      </div>
      <div className="relative z-10 max-w-sm space-y-3 text-center">
        <WifiOff className="mx-auto h-9 w-9 text-muted-foreground" />
        <h1 className="text-base font-semibold">No internet connection</h1>
        <p className="text-sm text-muted-foreground">
          There&apos;s a problem with your device&apos;s network connectivity. Check your connection and try again.
        </p>
      </div>
    </div>
  );
}
